/* 🤖 this file was generated by svg-to-ts */
export const matIconFastForward: {
  name: 'fast-forward';
  data: string;
} = {
  name: 'fast-forward',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15 9.86 18.03 12 15 14.14V9.86m-9 0L9.03 12 6 14.14V9.86M13 6v12l8.5-6L13 6zM4 6v12l8.5-6L4 6z"/></svg>`
};
